import { Flex } from '@pega/cosmos-react-core';
import React from 'react';
import styled, { css } from 'styled-components';

const commonBorderStyle = styled.div(
  ({ theme }) =>
    css`
      border-right: 1px solid ${theme.base.colors.gray.light};
      width: 548px;
      border-top-left-radius: 0.5rem;
    `,
);

const MultiUserExperience: React.FC = () => {
  return <Flex container={{ direction: 'row' }} as={commonBorderStyle} />;
};

export default MultiUserExperience;
